export default "__VITE_ASSET__24hif4Pv__"